import React from "react";
import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import ErrorMessage from "components/form/ErrorMessage";

const TextOtherField = ({ control, name, disabled, value }) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => {
        return (
          <TextField
            {...field}
            ref={field.ref}
            sx={{
              my: 0.5,
              "& .MuiInputBase-root.Mui-disabled": {
                color: "#000000de", // màu chữ
              },
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: "#000000de", // màu chữ
              },
              "& .MuiInputLabel-root.Mui-disabled": {
                color: "#000000de", // màu label khi disabled
              },
            }}
            value={value ? value : field.value}
            multiline
            disabled={disabled}
            error={error?.message}
            placeholder="Nhập thông tin khác"
            helperText={<ErrorMessage message={error?.message} />}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
            size="small"
            FormHelperTextProps={{ variant: "standard" }}
          />
        );
      }}
    />
  );
};

export default TextOtherField;
